import { gql } from '@apollo/client';
import { client } from 'graphql/client';

export const CHECK_DELIVERY_DRIVER_ACCOUNTS = gql`
    query CheckDeliveryDriverAccounts($phones: [String!]!) {
        checkDeliveryDriverAccounts(phones: $phones) {
            validDrivers {
                deliveryDriverId
                phone
                regionName
                warehouseName
                dspName
                hasActiveDelivery
            }
            invalidAccountIds
        }
    }
`;

export interface ValidDeliveryDriver {
    deliveryDriverId: number;
    phone: number | null;
    regionName: string | null;
    warehouseName: string | null;
    dspName: string | null;
    hasActiveDelivery: boolean;
}

export interface CheckDeliveryDriverAccountsResult {
    validDrivers: ValidDeliveryDriver[];
    invalidAccountIds: string[];
}

export interface CheckDeliveryDriverAccountsResponse {
    checkDeliveryDriverAccounts: CheckDeliveryDriverAccountsResult;
}

export const checkDeliveryDriverAccounts = async (phones: string[]): Promise<CheckDeliveryDriverAccountsResult> => {
    const { data } = await client.query<CheckDeliveryDriverAccountsResponse>({
        query: CHECK_DELIVERY_DRIVER_ACCOUNTS,
        variables: { phones },
        fetchPolicy: 'network-only',
    });
    return data.checkDeliveryDriverAccounts;
};
